// src/components/common/Layout/Layout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../common/Header/Header.jsx';
import { Footer } from '../../common/Footer/Footer.jsx';
import { CartWidget } from '../../widgets/CartWidget/CartWidget.jsx';
import { AuthModal } from '../../widgets/AuthModal/AuthModal.jsx';
import ToastProvider from '../../common/Toast/Toast.jsx';
import { CookieConsentBanner } from '../../common/CookieConsent/CookieConsentBanner.jsx';

export const Layout = () => {
  return (
    <ToastProvider>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Outlet />
        </main>
        <Footer />
        
        {/* Виджеты */}
        <CartWidget />
        {/* Вход и регистрация — ОДНА модалка поверх любой страницы
            (2026-10-29). Заменила старый `LoginWidget`: тот умел только
            вход, а регистрация была отдельной страницей, с которой
            человек уходил с витрины стикеров. */}
        <AuthModal />

        {/* Баннер согласия на куки. Показывается, только если сервер
            ответил «согласия нет» — см. разбор в самом компоненте.
            ⚠️ Бэкенд-часть (/api/v1/consent/*) ещё не сделана —
            см. ARCHITECTURE_TASKS.txt п.11. */}
        <CookieConsentBanner />
      </div>
    </ToastProvider>
  );
};